import { useEffect, useState } from "react";
import { NURI, NURI_HEADER_KEYS, NURI_TABLE_HEADER } from "../constants";
import useConjunctionDataLoader from "../hooks/useConjunctionDataLoader";

import Explanation from "../components/shared/ui/Explanation";
import { DATA_INFO, NURI_DESCRIPTIONS } from "../constants/descriptions";

import styled from "styled-components";
import Nuri3D from "../components/features/Nuri/Nuri3D";
import DataInfo from "../components/features/Malligyong/DataInfo";
import NuriEvent from "../components/features/Nuri/NuriEvent";
import { nuriIds } from "@graphic/constants/sats";

const NuriTracker = () => {
  const [enteringTime, setEnteringTime] = useState();
  const [selectedNoradId, setNoradId] = useState();
  const [secondaryID, setSecondaryID] = useState();
  const [selectedEvent, setSelectedEvent] = useState("TCA");
  const nuriTableData = useConjunctionDataLoader(nuriIds, selectedEvent);

  const handleSelectNuriData = idx => {
    const data = nuriTableData[idx];
    setEnteringTime(data[NURI_HEADER_KEYS.TCA]);
    setNoradId(data[NURI_HEADER_KEYS.PRIMARY]);
    setSecondaryID(data[NURI_HEADER_KEYS.SECONDARY]);
  };

  const NURIPROPS = {
    NURI_TABLE_HEADER,
    nuriTableData,
    handleSelectNuriData,
    selectedEvent,
    setSelectedEvent
  };

  useEffect(() => {
    if (!!nuriTableData) {
      const index = 0;
      const initialData = nuriTableData[index];
      setEnteringTime(initialData[NURI_HEADER_KEYS.TCA]);
      setNoradId(initialData[NURI_HEADER_KEYS.PRIMARY]);
      setSecondaryID(initialData[NURI_HEADER_KEYS.SECONDARY]);
    }
  }, [nuriTableData]);

  return (
    <Container>
      <DataInfo
        siteDescription={DATA_INFO.NURI.siteDescription}
        dataInfo={DATA_INFO.NURI.dataInfo}
      />
      <Explanation target={NURI_DESCRIPTIONS} />
      <NuriContainer>
        <Nuri3D
          enteringTime={enteringTime}
          selectedNoradId={selectedNoradId}
          secondaryID={secondaryID}
          NURI={NURI}
        />
        <NuriEvent NURIPROPS={NURIPROPS} title="Nuri-SAT (KSLV II)" />
      </NuriContainer>
    </Container>
  );
};

export default NuriTracker;

const Container = styled.main`
  position: relative;
  padding: 1rem;
  box-sizing: border-box;
  /* 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 3rem;
  width: auto;
  height: auto; */
`;

const NuriContainer = styled.div`
  gap: 3rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(35rem, 40rem));
  grid-template-rows: 45rem;
  justify-content: center;
  @media (max-width: 480px) {
    grid-template-columns: repeat(auto-fit, minmax(10rem, 35rem));
  }
`;
